import React from 'react';
import SilentRenew from '../components/auth/authSilentRenew';
import Logout from '../components/auth/Logout';
import LogoutCallback from '../components/auth/LogoutCallback';
import Callback from '../components/auth/authCallback';
import Dashboard from '../components/po';
import ExpenseItems from '../components/expenseItem';
import AddEditVendor from '../components/vendor/AddEditVendor';
import VendorListing from '../components/vendor/VendorListing';
import CreatePO from '../components/po/CreatePO';
import CreateAgencyPO from '../components/po/CreateAgencyPO';
import Logs from '../components/logs/Index';
import PPE from '../components/ppe/index';
import CreatePPE from '../components/ppe/CreatePPE';
import PODetailPage from '../components/po/PODetailPage';
import ItemsTable from '../components/ppe/ItemsTable';
import VesselCostCentre from '../components/vesselCostCentre';
import FixedBudgetVesselCompanyCode from '../components/fixedBudgetVesselCompanyCode';
import FixedBudgetVesselAccountCode from '../components/fixedBudgetVesselAccountCode';

const unAuthorised = React.lazy(() => import('../components/AuthPages/UnAuthorized'));
const PostLogout = React.lazy(() => import('../components/AuthPages/PostLogout'));

const routes = {
  publicRoutes: [
    { key: 1, path: '/authentication/callback', component: Callback },
    { key: 2, path: '/authentication/silent_callback', component: SilentRenew },
    { key: 3, path: '/logout', component: Logout },
    { key: 4, path: '/logout/callback', component: LogoutCallback },
    { key: 5, path: '/post-logout', component: PostLogout },
    { key: 6, path: '/unauthorized', component: unAuthorised }
  ],
  secureRoutes: [
    { key: 10, path: '/dashboard', component: <Dashboard />, hasNav: false, showHeader: false },
    { key: 11, path: '/expense-items', component: <ExpenseItems />, hasNav: false, showHeader: false },
    { key: 12, path: '/vendors', component: <VendorListing />, hasNav: false, showHeader: false },
    { key: 13, path: '/vendor/:vendorId', component: <AddEditVendor heading="Edit Vendor" />, hasNav: false, showHeader: false },
    { key: 14, path: '/create-po', component: <CreatePO mode="add" name="Create new PO" />, hasNav: false, showHeader: false },
    { key: 15, path: '/po/:poId', component: <PODetailPage />, hasNav: false, showHeader: false },
    { key: 16, path: '/edit-po/:poId', component: <CreatePO mode="edit" name="Edit PO" />, hasNav: false, showHeader: false },
    { key: 17, path: '/logs', component: <Logs />, hasNav: false, showHeader: false },
    { key: 18, path: '/ppe', component: <PPE />, hasNav: false, showHeader: false },
    { key: 19, path: '/ppe/:ppeId/:itemId', component: <CreatePPE />, hasNav: false, showHeader: false },
    { key: 20, path: '/ppe/:ppeId', component: <ItemsTable />, hasNav: false, showHeader: false },
    { key: 21, path: '/po/:poId/:isVendor', component: <PODetailPage />, hasNav: false, showHeader: false },
    { key: 22, path: '/create-agency-po', component: <CreateAgencyPO mode="add" name="Create new PO" />, hasNav: false, showHeader: false },
    { key: 23, path: '/edit-agency-po/:poId', component: <CreateAgencyPO mode="edit" name="Edit PO" />, hasNav: false, showHeader: false },
    { key: 24, path: '/cost-centres', component: <VesselCostCentre />, hasNav: false, showHeader: false },
    {
      key: 25,
      path: '/fixed-budget-vessel-company-codes',
      component: <FixedBudgetVesselCompanyCode />,
      hasNav: false,
      showHeader: false
    },
    {
      key: 26,
      path: '/fixed-budget-vessel-account-codes',
      component: <FixedBudgetVesselAccountCode />,
      hasNav: false,
      showHeader: false
    }
  ]
};
export default routes;
